import React, {Component} from 'react';
import { injectIntl } from 'react-intl';
import TransitionLink from 'components/transition-link/transition-link';
import Hero from 'components/heroes/hero';
import Page from 'components/page/page';
import messages from './messages';

class NotFound extends Component {
  constructor(props) {
    super(props);

    const { intl } = props;

    this.page = {
      'heading': intl.formatMessage(messages.heading),
      'intro': intl.formatMessage(messages.intro)
    };
  }

  _renderHero() {
    const { intl } = this.props;

    return (
      <Hero title={this.page.heading} supportingTxt={this.page.intro}>
        <div className="hero-action">
          <TransitionLink
            animateOnClick
            className="btn btn_dark btn_fixedWidth"
            to="/"
          >
            {intl.formatMessage(messages.go_home_label)}
          </TransitionLink>
        </div>
      </Hero>
    )
  }

  render() {
    const pageHero = this._renderHero();
    return (
      <Page fullTexture title={this.page.heading} pageHero={pageHero} />
    );
  }
}

export default injectIntl(NotFound);



// WEBPACK FOOTER //
// ./src/client/pages/errors/not-found.jsx